module.exports = __webpack_public_path__ + "static/media/skylinelogo.47718854.png";